export default __webpack_public_path__ + "static/webRotator/svg/0dde3d759f4a7859731f0d6912142441.svg";